import React from 'react'
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { activeNote, toggleFav } from '../../actions/notes';

export const JournalEntry = (note) => {
    const {id, date, title, body, url, fav} = note;
    const dispatch = useDispatch();
    const noteDate = moment(date)

    const handleEntryClick = () =>{
        dispatch(activeNote(id,note))
        document.querySelector('main').scrollIntoView()
    }

    const handleFav = () =>{
        dispatch(toggleFav(note))
    }
    return (
        <div 
        className="journal__entry pointer ld ld-fade-in" 
        style={{ animationDuration: '0.2s' }}
        >
            {
                url &&
            <div className="journal__entry-picture" 
            style={{
                backgroundSize:'cover',
                backgroundImage:`url(${url})`
            }}>
            </div>
            }

            <div className="journal__entry-body" onClick={handleEntryClick}>
                <p className="journal__entry-title">
                {title}
                </p>
                
                <p className="journal__entry-content">
                    {body}
                </p>
                
            </div>

            <div className="journal__entry-date-box">
            <span>{noteDate.format('dddd')}</span>
            <h4>{noteDate.format('Do')}</h4>
            <div onClick={handleFav}>
            {(fav) ?  <i className="fas fa-heart"></i> :<i className="far fa-heart"></i>}
            </div>

            </div>
        </div>
    )
}
